import { useMemo } from 'react';
import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const GET_SFDC_SETTINGS_FIELD_NAME = 'sfdcSettings';
export const GET_SFDC_SETTINGS = registerQuery({
  fieldName: GET_SFDC_SETTINGS_FIELD_NAME,
  fetcher() {
    return http.get(`sfdc/v1/settings`);
  }
});
export const useFetchSfdcSettings = () => {
  const {
    data,
    error,
    loading
  } = useQuery(GET_SFDC_SETTINGS, {
    variables: {}
  });
  return useMemo(() => {
    var _data$GET_SFDC_SETTIN;
    return {
      isSfdcSyncEnabled: (data === null || data === void 0 || (_data$GET_SFDC_SETTIN = data[GET_SFDC_SETTINGS_FIELD_NAME]) === null || _data$GET_SFDC_SETTIN === void 0 ? void 0 : _data$GET_SFDC_SETTIN.syncEnabled) || !loading && !error
    };
  }, [data, error, loading]);
};